module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_8017.85bcc6ce.png";